import { ComponentAdapter } from "@omegagrid/core";
import { DashboardItemSource, DashboardOptions as OGDashboardOptions } from "@omegagrid/dashboard";

export type DashboardOptions = OGDashboardOptions & {
	contextMenuButton?: boolean;
}

export abstract class DashboardAdapter extends ComponentAdapter {

	abstract getItems(): Promise<DashboardItemSource[]>|DashboardItemSource[];

	abstract getOptions(): Promise<DashboardOptions>|DashboardOptions;

	protected createOptions(options: Partial<DashboardOptions>): DashboardOptions {
		options = Object.assign({}, options);
		return options as DashboardOptions;
	}

}
